import { MouseEventHandler } from 'react';
import { GamePlayer, GamePlayerMark, GameVersus, PlayerO, PlayerX } from '../../utils';
import Button from '../Button';

import styles from './styles.module.css';

interface ResultProps {
  winner: GamePlayer | undefined;
  versus: GameVersus;
  mark: GamePlayer;
  confirmHandler?: MouseEventHandler;
  cancelHandler?: MouseEventHandler;
}

const Result = (props: ResultProps) => {

  const getPlayerMessage = () => {
    if (props.winner === undefined)
      return '';
    switch (props.versus) {
      case 'cpu':
        if (props.winner === props.mark)
          return 'YOU WON!';
        return 'OH NO, YOU LOST...';
      case 'player':
        if (props.winner === props.mark)
          return 'PLAYER 1 WINS!';
        return 'PLAYER 2 WINS!';;
    }
  }

  return (
    <div className={`${styles['result']}`}>
      <h4>{getPlayerMessage()}</h4>
      <div className={`${styles['mark']} ${props.winner === PlayerX && styles['blue']} ${props.winner === PlayerO && styles['yellow']}`}>
        {props.winner && GamePlayerMark[props.winner]}
        <h1>{props.winner ? 'Takes the round' : 'round tied'}</h1>
      </div>
      <div className={styles['buttons']}>
        <Button secondary color='silver' onClick={props.cancelHandler}>Quit</Button>
        <Button secondary color='yellow' onClick={props.confirmHandler}>Next Round</Button>
      </div>
    </div>
  );
};

export default Result;